export default __webpack_public_path__ + "6f2e218763e8693634ff360b774dfeff.jpg";